/**
 * Cookie Consent Banner Component
 * Created: 2025-11-06
 * Purpose: Display GDPR-compliant cookie consent banner (visual compliance only, no tracking enforcement)
 * Language: Polish (GDPR requirement for Polish users)
 */

import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { X } from 'lucide-react';

const COOKIE_CONSENT_KEY = 'autaro_cookie_consent';
const CONSENT_VERSION = 'v1';

export const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify({
      accepted: true,
      timestamp: new Date().toISOString(),
      version: CONSENT_VERSION
    }));
    setIsVisible(false);
  };

  const handleClose = () => {
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t-2 border-primary shadow-lg animate-slide-up">
      <div className="container mx-auto px-4 py-6 max-w-7xl">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="flex-1 pr-4">
            <p className="text-body font-heebo text-sm md:text-base leading-relaxed">
              Używamy plików cookies i podobnych technologii w celu świadczenia usług, zapewnienia funkcjonalności strony, 
              analizy ruchu oraz w celach marketingowych. Kontynuując przeglądanie, wyrażasz zgodę na ich wykorzystanie 
              zgodnie z naszą{' '}
              <a 
                href="/privacy" 
                className="text-iris hover:underline font-medium"
              >
                Polityką Prywatności
              </a>
              .
            </p>
          </div>
          
          <div className="flex items-center gap-3 w-full md:w-auto">
            <Button
              onClick={handleAccept}
              className="bg-primary hover:bg-primary/90 text-white font-heebo text-sm md:text-base px-6 py-2.5 w-full md:w-auto"
            >
              Akceptuję
            </Button>
            <Button
              onClick={handleClose}
              variant="ghost"
              size="icon"
              className="text-subtitle hover:text-body shrink-0"
              aria-label="Zamknij"
            >
              <X className="h-5 w-5" />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
